import AOS from 'aos';

document.addEventListener('DOMContentLoaded', () =>
  AOS.init({
    disable: 'mobile',
    delay: 50, // values from 0 to 3000, with step 50ms
    duration: 800, // values from 0 to 3000, with step 50ms
    once: true,
    offset: 0,
  })
);
